import { AxiosError } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { Enterprise } from '../auth';

export const GET_PARTNER_LIST = 'partners/GET_PARTNER_LIST';
export const GET_PARTNER_LIST_SUCCESS = 'partners/GET_PARTNER_LIST_SUCCESS';
export const GET_PARTNER_LIST_ERROR = 'partners/GET_PARTNER_LIST_ERROR';

export const DELETE_PARTNER = 'partners/DELETE_PARTNER';
export const DELETE_PARTNER_SUCCESS = 'partners/DELETE_PARTNER_SUCCESS';
export const DELETE_PARTNER_ERROR = 'partners/DELETE_PARTNER_ERROR';

/*
export const CREATE_PARTNER = 'partners/CREATE_PARTNER';
export const CREATE_PARTNER_SUCCESS = 'partners/CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_ERROR = 'partners/CREATE_PARTNER_ERROR';

export const UPDATE_PARTNER = 'partners/UPDATE_PARTNER';
export const UPDATE_PARTNER_SUCCESS = 'partners/UPDATE_PARTNER_SUCCESS';
export const UPDATE_PARTNER_ERROR = 'partners/UPDATE_PARTNER_ERROR';


*/

export const GET_PARTNER_DETAIL = 'partners/GET_PARTNER_DETAIL';
export const GET_PARTNER_DETAIL_SUCCESS = 'partners/GET_PARTNER_DETAIL_SUCCESS';
export const GET_PARTNER_DETAIL_ERROR = 'partners/GET_PARTNER_DETAIL_ERROR';

// export const ADD_USER_TO_PROJECT = 'partners/ADD_USER_TO_PROJECT';
// export const ADD_USER_TO_PROJECT_SUCCESS =
//   'partners/ADD_USER_TO_PROJECT_SUCCESS';
// export const ADD_USER_TO_PROJECT_ERROR = 'partners/ADD_USER_TO_PROJECT_ERROR';

export interface PartnerParams {
  enterpriseId: string;
  projectId?: string;
  partnerId?: string;
  // userIdList?: number[];
}

export const getPartnerListAsync = createAsyncAction(
  GET_PARTNER_LIST,
  GET_PARTNER_LIST_SUCCESS,
  GET_PARTNER_LIST_ERROR,
)<PartnerParams, Enterprise[], AxiosError>();

export const deletePartnerAsync = createAsyncAction(
  DELETE_PARTNER,
  DELETE_PARTNER_SUCCESS,
  DELETE_PARTNER_ERROR,
)<PartnerParams, number, AxiosError>();

/*
export const createPartnerAsync = createAsyncAction(
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_ERROR,
)<Enterprise, Enterprise, AxiosError>();

export const updatePartnerAsync = createAsyncAction(
  UPDATE_PARTNER,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_ERROR,
)<Enterprise, Enterprise, AxiosError>();


*/

export const getPartnerDetailAsync = createAsyncAction(
  GET_PARTNER_DETAIL,
  GET_PARTNER_DETAIL_SUCCESS,
  GET_PARTNER_DETAIL_ERROR,
)<PartnerParams, Enterprise, AxiosError>();

// export const addUserToProjectAsync = createAsyncAction(
//   ADD_USER_TO_PROJECT,
//   ADD_USER_TO_PROJECT_SUCCESS,
//   ADD_USER_TO_PROJECT_ERROR,
// )<PartnerParams, string, AxiosError>();
